<div class="widgets-container">
    <mat-toolbar class="grow-toolbar px-0 mb-24" fxLayout="row" fxLayoutAlign="space-between center">
        <div class="sidebar-btn" fxLayout="row" fxLayoutAlign="start center">
            <button mat-icon-button (click)="sidenavService.toggle()" *ngIf="!(screenWidth | isLargeScreen)">
                <mat-icon>apps</mat-icon>
            </button>
            <div *ngIf="experience">
                <div fxLayout="row" fxLayoutAlign="start center">
                    <button mat-icon-button class="mr-4" (click)="goBack()">
                        <mat-icon>arrow_back</mat-icon>
                    </button>
                    <div fxLayout="column">
                        <h5 class="parent-name">{{ experience.name }}</h5>
                        <h2>{{ 'ENGAGE.WIDGET.TITLE.PLURAL' | translate }}</h2>
                    </div>
                </div>
            </div>
        </div>
    </mat-toolbar>
    <div class="widgets">
        <mat-card appearance="outlined" class="p-0 mb-24 widget-card header-banner-stream mat-elevation-z0" *ngIf="stream.headerBannerStream">
            <div class="widget-card-image-container">
                <div mat-card-avatar class="widget-card-image"></div>
            </div>
            <mat-card-content fxLayout="column" fxLayoutAlign="center start">
                <span class="experiance-name">{{ stream.headerBannerStream.experianceName | translate }}</span>
                <h2 class="m-0">{{ stream.headerBannerStream.name | translate }}</h2>
                <p class="mt-8 mb-0">{{ 'ENGAGE.WIDGET.TYPE.HEADER_BANNER_STREAM' | translate }}</p>
                <p class="my-0">{{ stream.headerBannerStream.description | translate }}</p>
            </mat-card-content>
        </mat-card>
        <mat-card appearance="outlined" class="mb-12 p-0 widget-card featured-content mat-elevation-z0" *ngFor="let headerStream of stream.headerStream">
            <div class="widget-card-image-container">
                <div mat-card-avatar class="widget-card-image"></div>
            </div>
            <mat-card-content fxLayout="column" fxLayoutAlign="center start">
                <span class="experiance-name">{{ headerStream.experianceName | translate }}</span>
                <h2 class="m-0">{{ headerStream.name | translate }}</h2>
                <p class="mt-8 mb-0">{{ 'ENGAGE.WIDGET.TYPE.HEADER_STREAM' | translate }}</p>
                <p class="my-0">{{ headerStream.description | translate }}</p>
            </mat-card-content>
        </mat-card>
        <mat-card appearance="outlined" class="widget-card p-0 mb-12 mat-elevation-z0" *ngFor="let experienceWidget of experienceWidgets" [ngClass]="experienceWidget.type">
            <div class="widget-card-image-container">
                <div mat-card-avatar class="widget-card-image"></div>
            </div>
            <mat-card-content fxLayout="column" fxLayoutAlign="center start">
                <span class="experiance-name">{{ experienceWidget.experianceName | translate }}</span>
                <h2 class="m-0">{{ experienceWidget.name | translate }}</h2>
                <p class="mt-8 mb-0">{{ 'ENGAGE.WIDGET.TYPE.POSTING_STREAM' | translate }}</p>
                <p class="my-0">{{ experienceWidget.description | translate }}</p>
            </mat-card-content>
        </mat-card>
    </div>
</div>
